// extracted by mini-css-extract-plugin
export var contactSupport = "contact-support-module--contactSupport--0a9a7";
export var supportTitle = "contact-support-module--supportTitle--08068";